import React from 'react'
import PropTypes from 'prop-types'

import ActivityTypeNames from '../../../../ActivityTypes/shared/ActivityTypeNames'
import RecordThumbsContainer from 'modules/Records/shared/RecordThumbsContainer'

import '../ReportEntry.scss'
import Files from 'modules/Files/shared/Files'

const EntriesFootPatrol = ({ reportEntry }) => {
  const fields = reportEntry.fields || {}

  return (
    <div className="reportentry-container">
      {fields.activityTypeIds && (
        <div className="p-1">
          <ActivityTypeNames ids={fields.activityTypeIds} badge />
        </div>
      )}

      <div className="with-whitespace list-entry-light p-2">{fields.entry}</div>

      {fields.recordIds && (
        <div>
          <div className="bg-dark-500 font-bold px-4 py-2 text-right text-base-200">
            Linked Records
          </div>
          <RecordThumbsContainer recordIds={fields.recordIds} />
        </div>
      )}

      <Files fileUrls={fields.files} />
    </div>
  )
}

EntriesFootPatrol.propTypes = {
  reportEntry: PropTypes.object.isRequired,
}
EntriesFootPatrol.defaultProps = {}

export default EntriesFootPatrol
